import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home/Home";
import Cview from "../components/Curses/Cview";
import PrivateRoute from "./PrivateRoute";
import AdminPanel from "../pages/Admin/Admin";
import Navbar from "../components/layout/Navbar";
import CourseProfile from "../components/specific/CourseProfile";
import MyCourses from "../components/Curses/MyCourses";
import Icourse from "../components/IntroCourse/Icourse";
import MainAdmin from "../pages/Admin/Main";
import CoursesModuleMenu from "../pages/Admin/CoursesModuleMenu";
import RepositorioTable from "../pages/Admin/Repository";
import CoursesAssing from "../pages/Admin/CoursesAssing";
import MillionaireGame from "../components/IntroCourse/Qqsm/MillionaireGame";
import Questionaries from "../pages/Admin/Questionaries/Questionaries";
import ShowMyCoursesList from "../components/common/Forms/ShowMyCoursesList";
import CourseDetail from "../pages/Admin/CourseDetail"; 
import AdminRoute from "./AdminRoute";
import LeaderboardPage from "../pages/Leaderboard/LeaderboardPage";
import Banners from "../pages/Admin/Banners/Banners";
import Publicaciones from "../pages/Admin/Publicaciones/Publicaciones";
import LabelGroupsManager from "../pages/Admin/LabelGroups/LabelGroupsManager";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Página principal */}
      <Route path="/" element={<Home />} />

             {/* Rutas protegidas para usuarios autenticados */}
       <Route
         path="/courses"
         element={
           <PrivateRoute>
             <Navbar />
           </PrivateRoute>
         }
       >
         
         <Route path="profile" element={<CourseProfile />} />
         <Route path="getCourses" element={<Cview />} />
         <Route path="my-courses" element={<MyCourses />} />
         <Route path="Introcourse/:id" element={<Icourse />} />
         <Route path="millionaire-game/:id" element={<MillionaireGame />} />
       </Route>

       {/* Ruta del leaderboard */}
       <Route
         path="/leaderboard"
         element={
           <PrivateRoute>
             <Navbar />
           </PrivateRoute>
         }
       >
         <Route index element={<LeaderboardPage />} />
       </Route>

      {/* Rutas protegidas por rol de administrador */}
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          </PrivateRoute>
        }
      >
        <Route path="main" element={<MainAdmin />} />
        <Route path="courses" element={<CoursesModuleMenu />} />
        <Route path="repository" element={<RepositorioTable />} />
        <Route path="CoursesAssing" element={<CoursesAssing />} /> 
        <Route path="questionaires" element={<Questionaries />} /> 
        <Route path="CourseDetail" element={<CourseDetail />} />
        <Route path="ShowMyCoursesList" element={<ShowMyCoursesList/>} />
        <Route path="banners" element={<Banners />} />
        <Route path="publicaciones" element={<Publicaciones />} />
        <Route path="label-groups" element={<LabelGroupsManager />} />
      </Route>

      {/* Ruta por defecto si no encuentra coincidencias */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
